import type { TooltipProps } from "recharts";
import type { ValueType } from "recharts/types/component/DefaultTooltipContent";
import React from "react";

import { formatCurrencyCompact } from "@/utils";

export default function PortfolioSuperpositionsChartTooltip({ active, payload }: TooltipProps<ValueType, string>) {
  if (!active || !payload?.length) return null;

  const data = payload[0].payload;
  const date = new Date(data.timestamp * 1000);
  const formattedDate = `${date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  })} ${date.toLocaleDateString("en-US", {
    year: "2-digit",
  })}`;

  return (
    <div className="border-primary-500 bg-neutral-50 p-2 text-center">
      <p className="font-mono text-sm font-bold uppercase text-neutral-925">{formattedDate}</p>
      <p className="bold font-mono text-sm text-neutral-925">{formatCurrencyCompact(Number(data.balance_usd))}</p>
    </div>
  );
}
